import resolve from "ng";

export default (delay = 1000) => {
  const deferred = resolve("$q").defer();
  resolve("$timeout")(() => deferred.resolve(true), delay);
  return deferred.promise;
};
